import { TextInput, View } from 'react-native'
import { convertPercentageToNumber } from '~/utils'

import { styled } from '~/utils/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
      backgroundColor: 'transparent',
    },
    variants: {
      size: {
        medium: {
          height: theme.sizingMedium,
        },
        'medium-large': {
          height: theme.sizingMediumlarge,
        },
        large: {
          height: theme.sizingLarge,
        },
      },
    },
  }
})

export const InputContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorFormsBorderDefault,
      paddingLeft: theme.spacingInlineFourpulse,
      paddingRight: theme.spacingInlineOnepulse,
      paddingTop: theme.spacingInlineOnepulse,
      paddingBottom: theme.spacingInlineOnepulse,
      minWidth: 180,
      flex: 1,
      gap: theme.spacingStackOnepulse,
      backgroundColor: theme.colorFormsFillDefault,
    },
    variants: {
      size: {
        medium: {
          height: theme.sizingMedium,
        },
        'medium-large': {
          height: theme.sizingMediumlarge,
        },
        large: {
          height: theme.sizingLarge,
        },
      },
      hasFocused: {
        true: {
          backgroundColor: theme.colorFormsFillFocused,
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorActionBorderFocused,
        },
      },
      hasFill: {
        true: {
          backgroundColor: theme.colorFormsFillFocused,
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderFilled,
        },
      },
      hasFilledAndActive: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorActionBorderFocused,
          backgroundColor: theme.colorFormsFillFocused,
        },
      },
    },
  }
})

export const StyledInput = styled(TextInput, theme => {
  return {
    base: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: theme.fontSizeThreeandhalfpulse,
      fontWeight: '400',
      fontFamily: 'RDModern-Light',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralAlternative,
      textAlignVertical: 'center',
      textAlign: 'left',
      flex: 1,
      flexShrink: 1,
      borderWidth: 0,
      height: '100%',
      overflow: 'hidden',
    },
    variants: {
      hasFocused: {
        true: {
          color: theme.colorTextNeutralPlaceholder,
        },
      },
      hasFilledAndActive: {
        true: {
          color: theme.colorTextNeutralDefault,
        },
      },
    },
  }
})
